/** Lightweight chunk registry shared by App and Insights; importing it executes no panel code or API reads. */
import { deferredView } from "../../components/DeferredView.tsx";
import { enabledTabs } from "./tabs.ts";

// Module-scope lazy imports keep loaded views stable across navigation.
export const CostTab = deferredView(() => import("./CostTab.tsx").then((m) => ({ default: m.CostTab })));
export const OutcomesTab = deferredView(() => import("./OutcomesTab.tsx").then((m) => ({ default: m.OutcomesTab })));
export const DigestTab = deferredView(() => import("./DigestTab.tsx").then((m) => ({ default: m.DigestTab })));
export const PacingTab = deferredView(() => import("./PacingTab.tsx").then((m) => ({ default: m.PacingTab })));
export const CallQuality = deferredView(() => import("./CallQuality.tsx").then((m) => ({ default: m.CallQuality })));
export const VendorFunnel = deferredView(() => import("./VendorFunnel.tsx").then((m) => ({ default: m.VendorFunnel })));
export const VerifierAccuracy = deferredView(() => import("./VerifierAccuracy.tsx").then((m) => ({ default: m.VerifierAccuracy })));
export const Workflow = deferredView(() => import("./Workflow.tsx").then((m) => ({ default: m.Workflow })));

const panels = { cost: CostTab, outcomes: OutcomesTab, digest: DigestTab, pacing: PacingTab, quality: CallQuality, funnel: VendorFunnel, workflow: Workflow, verifier: VerifierAccuracy };
export function preloadInsightsTab(requested: string | null): Promise<unknown> | undefined {
  const tabs = enabledTabs();
  const tab = tabs.find((t) => t.id === requested) ?? tabs[0];
  return tab ? panels[tab.id].preload() : undefined;
}
